import React from 'react';
import { repositoriesWithProviderDetails } from 'state/selectors/repositories';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import TabsClipboards from 'components/base/TabsClipboard';

const PathsViewer = ({
  paths = [],
  selectedRepo,
  onRemoveValue = _.noop,
  onEditValue = _.noop,
  onRepoHeaderClick = _.noop
}) => {
  const repositories = useSelector(repositoriesWithProviderDetails);
  const repositoriesKeys = _.keyBy(repositories, 'id');

  const selectedRepoId = _.get(selectedRepo, 'id');
  const pathsRepos = paths.map(({ repository_id, paths }) => ({
    ...repositoriesKeys[repository_id],
    paths
  }));

  const tabs = pathsRepos.map(repo => ({
    key: _.get(repo, 'id'),
    title: _.get(repo, 'name'),
    logo: _.get(repo, 'provider.logo.svg'),
    data: _.get(repo, 'paths')
  }));

  return (
    <TabsClipboards
      tabs={tabs}
      selectedKey={selectedRepoId}
      onTabClick={repoId => onRepoHeaderClick(repositoriesKeys[repoId])}
      onRemoveValue={onRemoveValue}
      onEditValue={onEditValue}
    />
  );
};

export default PathsViewer;
